import React, {Component} from 'react';
import {IntlProvider} from 'react-intl';
import App from './App';
//import RegistrarChart from './RegistrarChart';
//import RegistrantChart from './RegistrantChart';
import Header from './Header';
import NoMatch from './NoMatch';

//import DomainChart from './DomainChart';
import ChartComponent from './charts/ChartComponent';

import * as i18n from '../i18n/';
import LocaleStore from '../store/LocaleStore';
//import { Router, Route, hashHistory, useRouterHistory, Redirect } from 'react-router';
import {browserHistory, Redirect, Route, Router} from 'react-router';
import {chartComponentConfiguration} from './charts/ChartComponentUtils';
import {checkQueryParams} from '../utils';


const Highcharts = window.Highcharts;

function highchartsITOption() {
  Highcharts.setOptions({
    lang: {
      months: ['Gennaio','Febbraio','Marzo','Aprile','Maggio','Giugno','Luglio','Agosto','Settembre','Ottobre','Novembre','Dicembre'],
      shortMonths: ['Gen','Feb','Mar','Apr','Mag','Giu','Lug','Ago','Set','Ott','Nov','Dic'],
      weekdays: ['Domenica', 'Lunedì','Martedì','Mercoledì','Giovedì','Venerdì','Sabato'],
      shortWekdays: ['Dom', 'Lun','Mar','Mer','Gio','Ven','Sab'],
      thousandsSep: '.',
      decimalPoint: ','
    }
  });
}


function highchartsENOption() {
  Highcharts.setOptions({
    lang: {
      months: ['January','February','March','April','May','June','July','August','September','October','November','December'],
      shortMonths: ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'],
      weekdays: ['Sunday', 'Monday','Tuesday','Wednesday','Thursday','Friday','Satuday'],
      shortWekdays: ['Sun', 'Mon','Tue','Wed','Thu','Fri','Sat'],
      thousandsSep: ',',
      decimalPoint: '.'
    }

    });
}

let highchartLocale = {
  it:highchartsITOption,
  en:highchartsENOption
}


class Main extends Component {
  constructor(props) {
    super(props);

    const {initialLocale: locale} = props;

    LocaleStore.setLocale(locale);
    highchartLocale[locale]();
    // Default locale
    this.state = {locale, messages:i18n[locale || 'it']};
    // Callback
    this.storeCallback=this.storeCallback.bind(this);

  }

  checkParams(kind, type) {
    let match = false;
    let matchString = "/"+ kind+"/"+type;
    if (chartComponentConfiguration[kind]) {
    chartComponentConfiguration[kind].tabs.forEach(function(tab,i) {
      match = match || (tab.link === matchString);
    });

    if (!match) {
      chartComponentConfiguration[kind].subtabs.forEach(function(subtab,i) {
        subtab.tabs.forEach(function(tab,j){
          match = match || (tab.link === matchString);
        })
      });
    }
    }
    return match;
  }

  componentWillMount() {
    LocaleStore.addChangeListener(this.storeCallback);
  }

  // Callback chiamato quando lo store emette cambiamento
  storeCallback() {
    var locale = LocaleStore.getLocale();

    if (this.state.locale !== locale) {

      highchartLocale[locale]();
      this.setState({locale, messages:i18n[locale]});

    }

  }

  // Configurazione statica del router
  render() {
    return (
      <IntlProvider key="intl" {...this.state}>
        <Router history={browserHistory} >
          <Redirect from="/" to="/domain/growth"/>
          <Route name="main" path="/" component={App}>
            <Redirect from="/domain" to="/domain/growth"/>
            <Redirect from="/registrar" to="/registrar/registration" query={{'zone':'all'}}/>
            <Redirect from="/registrant" to="/registrant/registration" query={{'zone':'all'}}/>

            <Route name="main" path="/:kind/:type(/:year)(/:month)(/:day)"
                  getComponents={(nextState, cb) => {

                    let errorOnQueryParams = chartComponentConfiguration[nextState.params.kind] && checkQueryParams(nextState.params.kind, nextState.params.type, nextState.location.query, chartComponentConfiguration[nextState.params.kind].queryParams);

                    let matchingParams = this.checkParams(nextState.params.kind, nextState.params.type);


                    if (chartComponentConfiguration[nextState.params.kind] && matchingParams && (errorOnQueryParams.length === 0))

                      cb(null, {header:Header, chart:ChartComponent});
                    else
                      cb(null, {header:Header, chart:NoMatch});
                  }}/>

                <Route name="nomatch" path="*"
                  components={{header:Header, chart:NoMatch}}/>

          </Route>
        </Router>
      </IntlProvider>
   )
 }
}

export default Main;



// WEBPACK FOOTER //
// ./src/components/Main.js